import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../utils/api';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (error) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <nav className="navbar">
        <Link to="/" className="navbar-brand">
          🎙️ Steinmetz Mumble
        </Link>
      </nav>

      <div className="container" style={{ maxWidth: '500px', marginTop: '4rem' }}>
        <div className="card">
          <h2 style={{ textAlign: 'center', marginBottom: '1rem', color: '#667eea' }}>
            Reset Your Password
          </h2>

          {submitted ? (
            <>
              <p style={{ textAlign: 'center', color: '#444' }}>
                If an account exists for <strong>{email}</strong>, we've sent a link to reset your password.
                Check your inbox (and spam folder).
              </p>
              <p style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                <Link to="/login" style={{ color: '#667eea', fontWeight: 'bold' }}>
                  Back to login
                </Link>
              </p>
            </>
          ) : (
            <>
              <p style={{ textAlign: 'center', color: '#666', marginBottom: '1.5rem' }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    className="form-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ width: '100%', marginTop: '1rem' }}
                  disabled={loading}
                >
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </button>
              </form>
              <p style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                <Link to="/login" style={{ color: '#667eea', fontWeight: 'bold' }}>
                  Back to login
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
